import script from "./IpView.vue?vue&type=script&setup=true&lang=js"
export * from "./IpView.vue?vue&type=script&setup=true&lang=js"

import "./IpView.vue?vue&type=style&index=0&id=2d2ebcc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2ebcc4"]])

export default __exports__